<div class="formly__wrapper">
  @if (displayHeader) {
    <div class="formly__object--body">
      @for (f of field.fieldGroup; track $index) {
        <formly-field [field]="f"></formly-field>
      }
    </div>
  }

  @if (!displayHeader) {
    <div>
      <div class="pb-2">
        @for (f of field.fieldGroup; track $index) {
          <formly-field [field]="f"></formly-field>
        }
      </div>
    </div>
  }
</div>
